<template>
  <div>
    <myHeader />
    <banner title="数据报送" />
    <div class="submit-main">
      <div class="submit-main-container">
        <div class="detail-container" v-html="content" />
        <div class="submit-main-3" @click="doDownLoad">
          <i class="el-icon-download icon"></i>
          <span>下载附件</span>
        </div>
      </div>
    </div>

    <myFooter bgc="black" />
  </div>
</template>

<script>

import Cookies from "js-cookie";
import {dataSendDetail} from "../../api/common";

export default {
  name: "Submit",
  data() {
    return {
      content: null,
      annexUrl: null,
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      dataSendDetail().then(res => {
        this.handleData(res.data)
      })
    },
    doDownLoad() {
      window.location.href = domain.api + this.annexUrl
    },
    handleData(res) {
      this.content = res.content
      this.annexUrl = res.annexUrl
    }
  }

}
</script>

<style scoped>
.submit-main {
  width: 100%;
}
.submit-main-container {
  width: 1140px;
  margin: 0 auto;
  min-height: 330px;
}
.submit-main-1 {
  margin: 45px 0 10px;
  font-size: 16px;
  font-weight: 400;
}

.submit-main-2 {
  font-size: 14px;
  font-weight: 400;
}

.submit-main-3 {
  margin-top: 23px;
  width: 112px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;

  border: 1px solid rgba(220, 220, 220, 1);

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 16px 5px 16px;
}

.icon {
  margin-right: 8px;
}</style>



// WEBPACK FOOTER //
// src/views/submit/index.vue